import React from "react";
import { useGlobalContext } from "store/contexts/globalContext";
import classNames from "classnames";
import { useDraggableContext } from "store/contexts/draggableModalContext";
import UserData from "./UserData";
import {
  ActionBar,
  AudioAction,
  ChatAction,
  LeaveAction,
  ParticipantAction,
  RecordAction,
  VideoAction,
  GalleryLayout,
  ScreenSharingAction,
  GalleryLayoutType,
  MeetingInfoAction,
} from "@ringcentral/video-sdk-react";
import "@ringcentral/video-sdk-react/dist/index.css";

function RingCentralComponentMeeting() {
  const { isMinimized, disabledDrag } = useDraggableContext();
  const { rcvEngine } = useGlobalContext();
  const meetingController = rcvEngine?.getMeetingController();

  return (
    <div
      className={classNames({
        "ringCentral-ui": true,
        "minimized-ringCentral": isMinimized ? true : false,
      })}
    >
      <div className="ring-central-container">
        {!isMinimized && (
          <GalleryLayout
            layout={GalleryLayoutType.gallery}
            style={{
              flex: 1,
            }}
          />
        )}
        {!disabledDrag && isMinimized && (
          <UserData meetingController={meetingController} />
        )}
        <ActionBar
          leftActions={[<MeetingInfoAction key={"meeting-info-action"} />]}
          centerActions={[
            <AudioAction
              key={"audio-action"}
              isShowLabel={true}
              localMuteCallback={(mute) => console.log("mute", mute)}
            />,
            <VideoAction key={"video-action"} isShowLabel={true} />,
            <ParticipantAction key={"participant-action"} isShowLabel={true} />,
            <ChatAction key={"chat-action"} isShowLabel={true} />,
            <RecordAction key={"record-action"} isShowLabel={true} />,
            <ScreenSharingAction isShowLabel={true} />,
            <LeaveAction key={"leave-action"} isShowLabel={true} />,
          ]}
        />
      </div>
    </div>
  );
}

export default RingCentralComponentMeeting;
